export default __webpack_public_path__ + "static/media/TREATMENT_TX.22cdd0ed.png";